{
  "accounts": {
    "actions": "Actions",
    "addToGroup": "Add to group…",
    "empty": "No accounts.",
    "filter": "Find an account",
    "filters": {
      "all": "All {{n}}",
      "approval": "Waiting for approval {{n}}",
      "disabled": "Disabled {{n}}",
      "invited": "Invited {{n}}"
    },
    "historyOnly": "History only",
    "putIn": "Put {{name}} into a group",
    "shown": "Show",
    "state": "State",
    "states": {
      "active": "Active",
      "disabled": "Disabled",
      "pending_approval": "Pending approval",
      "pending_verification": "Email not confirmed",
      "rejected": "Rejected"
    },
    "takeOut": "Take out of {{group}}"
  },
  "deletedProjects": {
    "deleted": "Deleted {{time}} by {{name}}",
    "hint": "Projects someone deleted. Restoring brings one back as it was. Once its restore period is over, it can be purged: its data is erased for good.",
    "none": "No project has been deleted.",
    "purge": "Purge",
    "purgeMessage": "Everything the project holds is erased and can't be brought back. Only its name and who deleted and purged it stay in this list.",
    "purgeNotBuilt": "Erasing a project's Runs, content and knowledge data isn't built yet. The project stays restorable.",
    "purgeNotYet": "It can still be restored. It can be purged from {{time}}.",
    "purgeTitle": "Purge {{project}} for good?",
    "purgeableFrom": "Can be purged from {{time}}",
    "purged": "Purged {{time}} by {{name}}",
    "restore": "Restore",
    "states": {"deleted": "Restorable", "purged": "Purged", "purging": "Purge not finished"},
    "title": "Deleted projects"
  },
  "groups": {"title": "Groups"},
  "installation": {
    "accessRequests": "People can ask for permissions they lack",
    "accessRequestsHint": "Where a permission is missing, people ask for it, and whoever could add them decides. Off, they're still told who decides.",
    "changed": "Changed: {{names}}",
    "creatorCurates": "A project's creator curates every kind of item",
    "deletedProjectRestoreDays": "Days a deleted project can be restored",
    "deletedProjectRestoreDaysHint": "Only after them can a deleted project be purged. A change counts for projects deleted afterwards.",
    "firstStart": "Set from the configuration file at the first start",
    "hint": "Limits, the groups new accounts join, and the rules new projects start with. Every change needs a reason.",
    "history": "Changes",
    "memberProjectLimit": "Projects one member may create",
    "memberProjectLimitHint": "Empty: no limit. Administrators have none.",
    "names": {
      "access_requests": "asking for access",
      "creator_curates": "creator curates",
      "deleted_project_restore_days": "restore period for deleted projects",
      "member_project_limit": "project limit",
      "members_create_projects": "members create projects",
      "new_account_groups": "groups new accounts join",
      "new_projects": "rules for new projects",
      "reasoning_levels": "reasoning effort per agent",
      "server_key_groups": "groups for the server's keys"
    },
    "newAccountGroups": "Groups new accounts join",
    "newAccountGroupsHint": "From now on, everyone whose account becomes active joins these groups.",
    "newProjects": "New projects start with",
    "newProjectsHint": "Each project can change its own rules afterwards. Changing these leaves existing projects as they are.",
    "noGroups": "No installation groups yet. Create one under Groups first.",
    "none": "The installation has no settings yet.",
    "reasoningLevels": "Reasoning effort per agent",
    "reasoningLevelsHint": "For Runs and people that leave it at Default, where the agent offers it.",
    "title": "Installation settings"
  },
  "invitations": {
    "by": "Invited by {{name}}",
    "into": "to {{project}}",
    "invited": "Invited",
    "joins": "joins {{groups}}",
    "revoke": "Revoke",
    "until": "until {{time}}"
  },
  "onlyAdministrators": "Only administrators administer the installation.",
  "pages": {
    "accounts": "Accounts",
    "deletedProjects": "Deleted projects",
    "groups": "Groups",
    "installation": "Installation",
    "researchSpace": "ResearchSpace",
    "serverKeys": "Server keys"
  },
  "title": "Administration"
}
